import { atom } from 'jotai';

/**
 * App initialization state
 * Tracks whether the app has been initialized
 */
export const appInitializedAtom = atom(false);
